<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
      <div @click="clone" v-if="this.entity.id">Clone</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li @click="clone" v-if="this.entity.id">
          <a href="#">
            Clone
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div class="col-xs-12 gap" v-if="entity.id">
          <div class="text-center">
            <div class="shadow platform">
              <div class="inner-tab-outer">
                  <span @click="tariffArea = 'lookup'" :class="[ tariffArea === 'lookup' ? 'vis' : '' ]" style="border-right:none;">Lookup</span>
                  <span @click="tariffArea = 'detail'" :class="[ tariffArea === 'detail' ? 'vis' : '' ]">Details</span>
              </div>
              <div class="inner-tab-outer">
                  <span @click="tariffArea = 'addition'" :class="[ tariffArea === 'addition' ? 'vis' : '' ]" style="border-top:none; border-right:none;">Additions</span>
                  <span @click="tariffArea = 'notes'" :class="[ tariffArea === 'notes' ? 'vis' : '' ]" style="border-top:none;">Notes</span>
              </div>
            </div>
          </div>
        </div>
        <div v-show="tariffArea === 'addition'">
          <div class="clearfix bg-wht col-xs-12">
            <accessorials
            :accs="accessorials"
            :lookup="this.entity.id"
            v-on:updating="data => this.accessorials = data"
            ></accessorials>
          </div>
        </div>
        <div v-show="tariffArea === 'detail'">
          <div class="clearfix bg-wht col-xs-12">
            <tariff-details
            :fetching="detailsPagination.fetching"
            :count="detailsPagination.count"
            @loadMore="getDetails('+')"
            @loadBack="getDetails('-')"
            :dets="details"
            :pageNumber="detailsPagination.page"
            :lookup="this.entity.id"
            v-on:updating="data => this.details = data"
            v-on:update-details-upload="updateDetails"
            @get-details="refreshDetails"
            ></tariff-details>
          </div>
        </div>
        <div v-show="tariffArea === 'notes'">
          <div class="clearfix bg-wht col-xs-12">
            <tariff-notes
            :notesProp="notes"
            :lookup="this.entity.id"
            v-on:updating="data => this.notes = data"
            ></tariff-notes>
          </div>
        </div>
        <div v-show="tariffArea === 'lookup'">
          <Merges
            :tariff="entity"
            @goToEdit="goToEditScreen"
            />
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="tariff-id" class="form-label">ID</label>
              <input type="number" disabled  class="form-control" id="tariff-id" :value="entity.id"/>
            </div>
            <div class="form-group">
              <label for="tariff-code" class="form-label">Code</label>
              <input disabled type="text" class="form-control" id="tariff-code" v-model="entity.code"/>
            </div>
            <div class="form-group">
              <label for="tariff-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="role-name" v-model="entity.name"/>
            </div>
            <div class="form-group">
              <label for="tariff-name" class="form-label">Description *</label>
              <input type="text" class="form-control" id="tariff-name" v-model="entity.description"/>
            </div>
            <div class="form-group">
              <label for="tariff-service-class" class="form-label">Service class *</label>
              <select class="form-control" id="tariff-service-class" v-model="entity.serviceClass">
                <option value=""></option>
                <option v-for="(opt, i) in serviceTypes" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Owner *</label>
              <autocomplete
                :dataset="partySearchResults"
                title="Owner"
                placeHolder="Type to search"
                :initVal="entity.owner"
                v-on:changing="data => partySearchText = data"
                :fnFormatText="displayParty"
                :fnSelectValue="displayParty"
                v-on:selection-made="selectOwner"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label for="tariff-lookup-type" class="form-label">Lookup Type</label>
              <select v-model="entity.lookupType" class="form-control" id="tariff-lookup-type">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('LOOKUP_TYPE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="is-state" class="form-label">Consolidated Service?</label>
              <div class="material-switch">
                <input id="is-state" type="checkbox" v-model="entity.consolidatedService"/>
                <label for="is-state" class="label-success"></label>
              </div>
            </div>
            <div class="form-group">
              <label for="tariff-contract-name" class="form-label">Contract Name</label>
              <input type="text" class="form-control" id="tariff-contract-name" v-model="entity.contractName"/>
            </div>
            <div class="form-group">
              <label for="tariff-breakpoint-per" class="form-label">Breakpoint Per</label>
              <select v-model="entity.breakpointPer" class="form-control" id="tariff-breakpoint-per">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('BREAKPOINT_UNIT')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="tariff-rate-per" class="form-label">Rates Per</label>
              <select v-model="entity.ratesPer" class="form-control" id="tariff-rate-per">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('BREAKPOINT_UNIT')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="tariff-ct" class="form-label">Container Type</label>
              <select v-model="entity.containerType" class="form-control" id="tariff-ct">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('CONTAINER_TYPE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="tariff-wl" class="form-label">Wood Loose</label>
              <select v-model="entity.woodLoose" class="form-control" id="tariff-wl">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('WOOD_LOOSE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="date-from" class="form-label">Effective From</label>
              <input class="mai-date" type="date" v-model="entity.effectiveFrom"/>
            </div>
            <div class="form-group">
              <label for="date-from" class="form-label">Effective To</label>
              <input class="mai-date" type="date" v-model="entity.effectiveTo"/>
              <!--<date-picker :date="effectiveTo" :option="dateOption"></date-picker>-->
            </div>
            <div class="form-group">
              <label for="date-nud" class="form-label">Next update due</label>
              <input class="mai-date" type="date" v-model="entity.nextUpdateDue"/>
              <!--<date-picker :date="nextUpdateDue" :option="dateOption"></date-picker>-->
            </div>
            <div class="form-group">
              <label for="date-purge" class="form-label">Purge date</label>
              <input class="mai-date" type="date" v-model="entity.purgeDate"/>
              <!--<DateP v-model="entity.purgeDate" format="yyyy-MM-dd" input-class="form-control"/>-->
              <!--<date-picker :date="purgeDate" :option="dateOption"></date-picker>-->
            </div>
            <div class="form-group">
              <label for="tariff-dur-type" class="form-label">Duration type</label>
              <select class="form-control" id="tariff-dur-type" v-model="entity.timeType">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('DURATION_TYPE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="tariff-distance-type" class="form-label">Distance type</label>
              <select class="form-control" id="tariff-distance-type" v-model="entity.distanceType">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('DISTANCE_TYPE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="tariff-brand" class="form-label">Brand</label>
              <select class="form-control" id="tariff-distance-type" v-model="entity.brand">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('BRAND')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="tariff-brand" class="form-label">Min. density type</label>
              <select class="form-control" id="tariff-distance-type" v-model="entity.minimumDensityType">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('UNIT_TYPE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="tariff-unit-type" class="form-label">Unit type</label>
              <select class="form-control" id="tariff-unit-type" v-model="entity.unitType">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('UNIT_TYPE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="tariff-spec-business-en" class="form-label">Specific to business entity group</label>
              <select class="form-control" id="tariff-spec-business-en" v-model="entity.specificToBusinessEntityGroup">
                <option value=""></option>
                <option v-for="(opt, i) in partyGroups" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Specific to business entity</label>
              <autocomplete
                :dataset="partySearchResults"
                title="Specific to business entity"
                placeHolder="Type to search"
                :initVal="entity.specificToBusinessEntity"
                v-on:changing="data => partySearchText = data"
                :fnFormatText="displayParty"
                :fnSelectValue="displayParty"
                v-on:selection-made="selectBusinessEntity"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label for="tariff-spec-agent-group" class="form-label">Specific to agent group</label>
              <select class="form-control" id="tariff-spec-agent-group" v-model="entity.specificToAgentGroup">
                <option value=""></option>
                <option v-for="(opt, i) in partyGroups" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Specific to agent</label>
              <autocomplete
                :dataset="partySearchResults"
                title="Specific to agent"
                placeHolder="Type to search"
                :initVal="entity.specificToAgent"
                v-on:changing="data => partySearchText = data"
                :fnFormatText="displayParty"
                :fnSelectValue="displayParty"
                v-on:selection-made="selectAgent"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label for="tariff-min-density" class="form-label">Minimum Density</label>
              <input type="number" v-model="entity.minimumDensity" class="form-control" id="tariff-min-density" step="0.01"/>
            </div>
            <div class="form-group">
              <label for="tariff-min-rate" class="form-label">Minimum Rate</label>
              <input type="number" v-model="entity.minimumRate" class="form-control" id="tariff-min-rate" step="0.01"/>
            </div>
            <div class="form-group">
              <label for="tariff-mode" class="form-label">Mode</label>
              <select v-model="entity.mode" class="form-control" id="tariff-mode">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('MODE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="tariff-shipment-type" class="form-label">Shipment Type</label>
              <select v-model="entity.shipmentType" class="form-control" id="tariff-shipment-type">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('SHIPMENT_CATEGORY')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="tariff-transport-type" class="form-label">Transport Type</label>
              <select v-model="entity.transportType" class="form-control" id="tariff-transport-type">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('TRANSPORT_TYPE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="tariff-goods-type" class="form-label">Goods Type</label>
              <select v-model="entity.goodsType" class="form-control" id="tariff-goods-type">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('GOODS_TYPE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="supress-bp" class="form-label">Suppress Breakpoints?</label>
              <div class="material-switch">
                <input id="supress-bp" type="checkbox" v-model="entity.suppressBreakpoints"/>
                <label for="supress-bp" class="label-success"></label>
              </div>
            </div>
            <div class="form-group">
              <label for="suspended" class="form-label">Suspended?</label>
              <div class="material-switch">
                <input id="suspended" type="checkbox" v-model="entity.suspended"/>
                <label for="suspended" class="label-success"></label>
              </div>
            </div>
            <div class="form-group">
              <label for="currency" class="form-label">Lookup Currency</label>
              <select class="form-control" id="currency" v-model="entity.lookupCurrency">
                <option value=""></option>
                <option v-for="(opt, i) in currencies" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="currency" class="form-label">Pre-Carriage Currency</label>
              <select class="form-control" id="currency" v-model="entity.preCarriageCurrency">
                <option value=""></option>
                <option v-for="(opt, i) in currencies" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="currency" class="form-label">On-Carriage Currency</label>
              <select class="form-control" id="currency" v-model="entity.onCarriageCurrency">
                <option value=""></option>
                <option v-for="(opt, i) in currencies" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="tariff-max-charge" class="form-label">Maximum Charge</label>
              <input type="number" v-model="entity.maximumCharge" class="form-control" id="tariff-max-charge" step="0.01"/>
            </div>
            <div class="form-group">
              <label for="left-join-key" class="form-label">Left Join Key</label>
              <input v-model="entity.leftJoinKey" class="form-control" id="left-join-key" />
            </div>
            <div class="form-group">
              <label for="right-join-key" class="form-label">Right Join Key</label>
              <input v-model="entity.rightJoinKey" class="form-control" id="right-join-key" />
            </div>
            <div class="form-group">
              <label for="restricted-left-join" class="form-label">Restricted Left Join?</label>
              <div class="material-switch">
                <input id="restricted-left-join" type="checkbox" v-model="entity.restrictedLeftJoin" />
                <label for="restricted-left-join" class="label-success"></label>
              </div>
            </div>
            <div class="form-group">
              <label for="restricted-right-join" class="form-label">Restricted Right Join?</label>
              <div class="material-switch">
                <input id="restricted-right-join" type="checkbox" v-model="entity.restrictedRightJoin" />
                <label for="restricted-right-join" class="label-success"></label>
              </div>
            </div>
            <div class="form-group">
              <label for="tariff-ext-id" class="form-label">External ID</label>
              <input type="number" v-model="entity.externalId" class="form-control" id="tariff-ext-id" step="1"/>
            </div>
            <div class="form-group">
              <label for="tariff-category" class="form-label">Category</label>
              <select class="form-control" id="tariff-category" v-model="entity.category">
                <option value="" />
                <option v-for="(opt, i) in categories" :value="opt">{{ opt }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import DatePicker from 'vue-datepicker/vue-datepicker-es6.vue'
  import DateP from 'vuejs-datepicker'
  import dateConfig from '../../../../../static/js/date-picker-config.json'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import CalculatedFieldsMixin from '../../../helpers/CalculatedFieldsMixin'
  import Accessorials from './TariffAdditions.vue'
  import TariffDetails from './TariffDetails.vue'
  import TariffNotes from './TariffNotes.vue'
  import API from '../../../../api/endpoints'
  import event from '../../../../event'
  import Merges from './MergeComponents'
  import { addCryptRouteId } from '../../../helpers/RouteHash'
  export default {
    name: 'Tariff',
    mixins: [AdminEntityMixin, HelperMixin, CalculatedFieldsMixin],
    components: {
      DatePicker,
      Autocomplete,
      Accessorials,
      TariffDetails,
      TariffNotes,
      Merges,
      DateP
    },
    data () {
      return {
        doingUpdate: false,
        tariffArea: 'lookup',
        transformForUpdate: {
          lookupType: this.toMinus,
          breakpointPer: this.toMinus,
          ratesPer: this.toMinus,
          mode: this.toMinus,
          transportType: this.toMinus,
          goodsType: this.toMinus,
          lookupCurrency: this.toMinus,
          shipmentType: this.toMinus,
          unitType: this.toMinus,
          timeType: this.toMinus,
          distanceType: this.toMinus,
          minimumRate: this.toZero,
          minimumDensity: this.toZero,
          maximumCharge: this.toZero,
          brand: this.toMinus,
          serviceClass: this.toMinus,
          minimumDensityType: this.toMinus,
          externalId: this.toZero,
          preCarriageCurrency: this.toMinus,
          onCarriageCurrency: this.toMinus,
          owner: this.toMinus,
          specificToBusinessEntityGroup: this.toMinus,
          specificToAgentGroup: this.toMinus,
          specificToBusinessEntity: this.toMinus,
          specificToAgent: this.toMinus,
          containerType: this.toMinus,
          woodLoose: this.toMinus
        },
        onLoadTransformations: {
          effectiveFrom: this.fromTimestamp,
          effectiveTo: this.fromTimestamp,
          purgeDate: this.fromTimestamp,
          nextUpdateDue: this.fromTimestamp
        },
        effectiveTo: {
          time: window.getYMDDate()
        },
        effectiveFrom: {
          time: window.getYMDDate()
        },
        nextUpdateDue: {
          time: window.getYMDDate()
        },
        purgeDate: {
          time: window.getYMDDate()
        },
        newEntityScreen: 'Admin - Tariffs',
        editEntityScreen: 'Admin - Edit/View Tariff',
        tab: 'main',
        boxes: [
          {
            prop: 'breakpointPer',
            id: 'id'
          },
          {
            prop: 'ratesPer',
            id: 'id'
          },
          {
            prop: 'mode',
            id: 'id'
          },
          {
            prop: 'shipmentType',
            id: 'id'
          },
          {
            prop: 'goodsType',
            id: 'id'
          },
          {
            prop: 'containerType',
            id: 'id'
          },
          {
            prop: 'woodLoose',
            id: 'id'
          },
          {
            prop: 'transportType',
            id: 'id'
          },
          {
            prop: 'lookupCurrency',
            id: 'id'
          },
          {
            prop: 'unitType',
            id: 'id'
          },
          {
            prop: 'timeType',
            id: 'id'
          },
          {
            prop: 'distanceType',
            id: 'id'
          },
          {
            prop: 'lookupType',
            id: 'id'
          },
          {
            prop: 'brand',
            id: 'id'
          },
          {
            prop: 'serviceClass',
            id: 'id'
          },
          {
            prop: 'minimumDensityType',
            id: 'id'
          },
          {
            prop: 'preCarriageCurrency',
            id: 'id'
          },
          {
            prop: 'onCarriageCurrency',
            id: 'id'
          },
          {
            prop: 'specificToBusinessEntityGroup',
            id: 'id'
          },
          {
            prop: 'specificToAgentGroup',
            id: 'id'
          }
        ],
        accessorials: [],
        details: [],
        detailsPagination: {
          page: 0,
          count: 0,
          fetching: false
        },
        notes: [],
        entity: {
          id: null,
          code: null,
          name: null,
          description: null,
          consolidatedService: null,
          contractName: null,
          breakpointPer: null,
          ratesPer: null,
          effectiveFrom: window.getYMDDate(),
          effectiveTo: window.getYMDDate(),
          nextUpdateDue: window.getYMDDate(),
          purgeDate: window.getYMDDate(),
          minimumDensity: null,
          minimumRate: null,
          mode: null,
          shipmentType: null,
          goodsType: null,
          transportType: null,
          suppressBreakpoints: null,
          suspended: 0,
          lookupCurrency: null,
          unitType: null,
          timeType: null,
          distanceType: null,
          lookupType: null,
          maximumCharge: null,
          brand: null,
          serviceClass: null,
          minimumDensityType: null,
          externalId: null,
          preCarriageCurrency: null,
          onCarriageCurrency: null,
          specificToBusinessEntityGroup: null,
          specificToAgentGroup: null,
          specificToBusinessEntity: null,
          specificToAgent: null,
          containerType: null,
          woodLoose: null,
          leftJoinKey: null,
          rightJoinKey: null,
          restrictedLeftJoin: null,
          restrictedRightJoin: null,
          owner: null,
          mergeComponent1: null,
          mergeComponent2: null,
          mergeComponent3: null,
          category: null
        },
        entityName: 'lookup',
        dateOption: dateConfig
      }
    },
    watch: {
      'effectiveTo.time' (newVal, oldVal) {
        if (this.entity.effectiveTo !== newVal) {
          this.entity.effectiveTo = newVal
        }
      },
      'effectiveFrom.time' (newVal, oldVal) {
        if (this.entity.effectiveFrom !== newVal) {
          this.entity.effectiveFrom = newVal
        }
      },
      'entity.effectiveFrom' (newVal, oldVal) {
        if (this.effectiveFrom.time !== newVal) {
          this.effectiveFrom.time = newVal
        }
      },
      'entity.effectiveTo' (newVal, oldVal) {
        if (this.effectiveTo.time !== newVal) {
          this.effectiveTo.time = newVal
        }
      },
      'entity.owner' (newVal, oldVal) {
        if (typeof newVal === 'object' && typeof newVal !== 'undefined') {
          if (newVal.hasOwnProperty('code')) {
            this.entity.code = newVal.code
          } else if (Object.keys(newVal).length === 0 || newVal === null) {
            this.entity.code = ''
          }
        }
      },
      'nextUpdateDue.time' (newVal, oldVal) {
        if (this.entity.nextUpdateDue !== newVal) {
          this.entity.nextUpdateDue = newVal
        }
      },
      'purgeDate.time' (newVal, oldVal) {
        if (this.entity.purgeDate !== newVal) {
          this.entity.purgeDate = newVal
        }
      },
      'entity.nextUpdateDue' (newVal, oldVal) {
        if (this.nextUpdateDue.time !== newVal) {
          this.nextUpdateDue.time = newVal
        }
      },
      'entity.purgeDate' (newVal, oldVal) {
        if (this.purgeDate.time !== newVal) {
          this.purgeDate.time = newVal
        }
      },
      '$route' (newVal, oldVal) {
        this.tariffArea = 'lookup'
        this.initRelations()
        this.getRelatedData()
      }
    },
    computed: {
      isValid () {
        return this.entity.name && this.entity.description &&
        this.entity.name.trim().length > 0 && this.entity.description.trim().length > 0 &&
        this.entity.owner !== null && typeof this.entity.owner === 'object' &&
        this.entity.owner.hasOwnProperty('id') && this.entity.owner.id &&
        this.entity.serviceClass !== null && this.entity.serviceClass !== '' &&
        (!this.entity.restrictedLeftJoin || this.entity.leftJoinKey) &&
        (!this.entity.restrictedRightJoin || this.entity.rightJoinKey)
      },
      currencies () {
        return this.$store.getters['systemOption/currencies']
      },
      serviceTypes () {
        return this.$store.getters['systemOption/serviceTypes']
      },
      partyGroups () {
        return this.$store.getters['systemOption/partyGroups']
      },
      maxPage () {
        return Math.ceil(this.detailsPagination.count / 500)
      },
      categories () {
        return ['COST', 'CHARGE']
      }
    },
    methods: {
      shouldLoad (op) {
        return !(op === '-' && this.detailsPagination.page === 1) &&
        !(op === '+' && this.detailsPagination.page === this.maxPage)
      },
      initRelations () {
        this.detailsPagination.page = 0
        this.detailsPagination.count = 0
        this.detailsPagination.fetching = false
        this.doDetailsCount()
      },
      doDetailsCount () {
        const newId = this.$route.params.id ? parseInt(addCryptRouteId(this.$route.params.id)) : null
        this.$http.get(API.GET_ENTITIES('lookup-detail'), {
          params: {
            lookup: newId
          },
          headers: { 'X-Count-Fetch': 'true' }
        }).then(({data}) => {
          this.detailsPagination.count = data.value
        }).catch(console.log)
      },
      preSaveRoutine () {
        return Promise.resolve()
      },
      /*
      preSaveRoutine () {
        if (this.entity.id) {
          return this.doCalculations(this.entity.id)
        } else {
          return Promise.resolve()
        }
      },
      */
      updateDetails (data) {
        data.forEach(obj => {
          let unwrapped = this.unwrapRelatedData(obj, ['containerType', 'woodLoose'])
          let current = this.details.find(({id}) => id === obj.id)
          if (current) {
            for (let prop in unwrapped) {
              current[prop] = unwrapped[prop]
            }
          } else {
            this.details.push(unwrapped)
          }
        })
      },
      clone () {
        event.$emit('loading-on', { title: 'Cloning existing tariff and associated information' })
        this.$store.dispatch('admin/cloneTariffRequest', this.entity.id)
        .then(data => {
          event.$emit('toast', { type: 'success', message: 'Tariff cloned' })
          this.$store.dispatch('admin/updateEntity', { entity: 'lookup', data })
          .then(res => this.goToEditScreen(data.id))
          .catch(err => console.log(err))
        })
        .catch(err => {
          console.log(err)
        }).then(() => {
          event.$emit('loading-off')
        })
      },
      selectOwner (o) {
        this.entity.owner = o
        this.partySearchText = ''
        this.partySearchResults = []
      },
      selectBusinessEntity (o) {
        this.entity.specificToBusinessEntity = o
        this.partySearchText = ''
        this.partySearchResults = []
      },
      selectAgent (o) {
        this.entity.specificToAgent = o
        this.partySearchText = ''
        this.partySearchResults = []
      },
      displayParty (p) {
        let str = `${p.name}, ${p.code}`
        if (p.address !== null) {
          str += `, ${p.address.subdivision}`
          if (p.address.country !== null) {
            str += `, ${p.address.country.code}`
          }
        }
        return str
      },
      getBaseData () {
        return {
          id: null,
          code: null,
          name: null,
          description: null,
          consolidatedService: null,
          contractName: null,
          breakpointPer: null,
          ratesPer: null,
          effectiveFrom: window.getYMDDate(),
          effectiveTo: window.getYMDDate(),
          nextUpdateDue: window.getYMDDate(),
          purgeDate: window.getYMDDate(),
          minimumDensity: null,
          minimumRate: null,
          mode: null,
          shipmentType: null,
          goodsType: null,
          transportType: null,
          suppressBreakpoints: null,
          suspended: 0,
          lookupCurrency: null,
          unitType: null,
          timeType: null,
          distanceType: null,
          lookupType: null,
          maximumCharge: null,
          brand: null,
          serviceClass: null,
          minimumDensityType: null,
          externalId: null,
          preCarriageCurrency: null,
          onCarriageCurrency: null,
          specificToBusinessEntityGroup: null,
          specificToAgentGroup: null,
          specificToBusinessEntity: null,
          specificToAgent: null,
          containerType: null,
          woodLoose: null,
          leftJoinKey: null,
          rightJoinKey: null,
          restrictedLeftJoin: null,
          restrictedRightJoin: null,
          owner: null,
          mergeComponent1: null,
          mergeComponent2: null,
          mergeComponent3: null,
          category: null
        }
      },
      getRelatedData () {
        if (this.entity.id !== null && this.entity.id > 0) {
          this.doFetchRelatedData()
        } else {
          this.accesorials = []
          this.details = []
          this.notes = []
        }
      },
      unwrapRelatedData (obj, propsToUnbox = false) {
        let data = {}
        for (let prop in obj) {
          if (typeof obj[prop] === 'object' && obj[prop] !== null && obj[prop].hasOwnProperty('id') && (!propsToUnbox || propsToUnbox.includes(prop))) {
            data[prop] = obj[prop].id
          } else {
            data[prop] = obj[prop]
          }
        }
        return data
      },
      doFetchRelatedData () {
        const newId = this.$route.params.id ? parseInt(addCryptRouteId(this.$route.params.id)) : null
        if (newId) {
          event.$emit('loading-on', { title: 'Setting up Tariff' })
          let additions = this.$http.get(API.GET_ENTITIES('lookup-addition'), { params: { lookup: newId } })
          let details = this.getDetails('+', true)
          let notes = this.$http.get(API.GET_ENTITIES('note'), { params: { lookup: newId } })
          this.syncAdditions(additions)
          this.syncNotes(notes)
          Promise.all([additions, details, notes]).then(res => event.$emit('loading-off'))
          .catch(e => {
            console.log(e)
            event.$emit('loading-off')
            event.$emit('toast', { type: 'error', message: 'Unable to load all resources' })
          })
        }
      },
      refreshDetails () {
        const newId = this.$route.params.id ? parseInt(addCryptRouteId(this.$route.params.id)) : null
        let details = !this.detailsPagination.fetching
          ? this.$http.get(API.GET_ENTITIES('lookup-detail'), {
            params: {
              lookup: newId
            },
            headers: {
              'X-Lazy-Fetch': '0',
              'X-Limit': '500',
              'X-Page-Number': String(this.detailsPagination.page)
            }
          })
          : Promise.resolve({ data: { ignore: true } })
        this.syncDetails(details)
      },
      getDetails (op, force = false) {
        const newId = this.$route.params.id ? parseInt(addCryptRouteId(this.$route.params.id)) : null
        let details = !this.detailsPagination.fetching && (this.shouldLoad(op) || force)
        ? this.$http.get(API.GET_ENTITIES('lookup-detail'), {
          params: {
            lookup: newId
          },
          headers: {
            'X-Lazy-Fetch': '0',
            'X-Limit': '500',
            'X-Page-Number': String(op === '+' ? ++this.detailsPagination.page : --this.detailsPagination.page)
          }
        })
        : Promise.resolve({ data: { ignore: true } })
        this.syncDetails(details)
        return details
      },
      syncAdditions (additions) {
        additions.then(({data}) => {
          this.accessorials = data.map(obj => this.unwrapRelatedData(obj))
        }).catch(err => {
          this.accessorials = []
          console.log(err)
        })
      },
      syncDetails (details) {
        this.detailsPagination.fetching = true
        details.then(({data}) => {
          if (!data.ignore) {
            this.details = data.map(obj => {
              obj.selected = false
              return this.unwrapRelatedData(obj, ['containerType', 'woodLoose'])
            })
          }
        }).catch(err => {
          this.details = []
          console.log(err)
        }).then(() => {
          this.detailsPagination.fetching = false
        })
      },
      syncNotes (notes) {
        notes.then(({data}) => {
          this.notes = data
        }).catch(err => {
          this.details = []
          console.log(err)
        })
      }
    },
    mounted () {
      this.initRelations()
      this.getRelatedData()
    },
    beforeUpdate () {
      const newId = this.$route.params.id ? parseInt(addCryptRouteId(this.$route.params.id)) : null
      if (this.entity.id !== newId && !this.doingUpdate) {
        this.doingUpdate = true
        event.$emit('loading-on', {})
        this.$store.dispatch('admin/getEntity', { entity: 'lookup', id: newId })
         .then(this.initData)
         .catch(console.log)
         .then(() => {
           this.doingUpdate = false
           event.$emit('loading-off', {})
         })
      }
    }
  }
</script>
<style>
.gap {
  margin-top: 20px;
  margin-bottom: 20px;
}
.inner-tab-outer {
  font-size: 0;
}
.inner-tab-outer span {
  font-size: 14px;
  padding: 7px 12px;
  border: 1px solid #949292;
  color: #949292;
  display: inline-block;
  width: 80px;
  cursor:pointer;
}
.inner-tab-outer span.vis {
  background-color: #949292;
  color: #fff;
}
.bg-wht {
  background: #fff;
  padding: 10px;
}
.platform {
  padding: 10px 50px;
  display: inline-block;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Tariff/Tariff.vue